<template>
    <Songbird 
      v-if="showDefaultLogo"
      :constant="constant"
      :width="props.width"
      :height="props.height"
      :size="props.size"
      :color="props.color"
      :stroke="stroke"
    />
    <SongbirdStroke 
      v-else-if="showStrokeLogo"
      :color="props.color"
    />
    <SongbirdActiveSmall 
      v-else-if="showActiveSmallLogo"
      :width="props.width"
      :height="props.height"
      :size="props.size"
      :color="props.color"
    />
    <SongbirdDeactiveSmall 
      v-else
    />
</template>
<script setup>
  import { computed } from 'vue'
  import Songbird from './Songbird.vue'
  import SongbirdStroke from './SongbirdStroke.vue'
  import SongbirdActiveSmall from './SongbirdActiveSmall.vue'
  import SongbirdDeactiveSmall from './SongbirdDeactiveSmall.vue'

  const props = defineProps({
    constant: {
      type: Object,
      default: () => {}
    },
    isActiveNetwork: {
      type: Boolean,
      default: false
    },
    isActiveNetworkSubNav: {
      type: Boolean,
      default: false
    },
    showSolidDefaultLogo: {
      type: Boolean,
      default: false
    },
    showCircleLogo: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 14
    },
    height: {
      type: Number,
      default: 14
    },
    size: {
      type: Number,
      default: 1.0
    },
    color: {
      type: String,
      default: '000000'
    },
    stroke: {
      type: Boolean,
      default: false
    }
  })

  const constant = props.constant

  const showDefaultLogo = computed(() => {
    return props.showSolidDefaultLogo && props.isActiveNetwork
  })
  
  const showStrokeLogo = computed(() => {
    return !props.isActiveNetworkSubNav && props.isActiveNetwork && !props.showCircleLogo
  })

  const showActiveSmallLogo = computed(() => {
    return (props.isActiveNetworkSubNav && props.isActiveNetwork) || (props.showCircleLogo && props.isActiveNetwork)
  })
</script>
